








import { Component, Vue } from 'vue-property-decorator';
import Viewport from './components/Viewport.vue';
import Sidebar from './components/Sidebar.vue';
import Popup from './components/Popup.vue';

import Bench from './assets/bench.jpg';
import Phone from './assets/phone.png';
import Tree from './assets/tree.png';

@Component({
  components: {
    Viewport,
    Sidebar,
    Popup
  },
})
export default class App extends Vue {
  private showPopUp = true;
  private popUpImage = Bench;

  public mounted() {
    const rand = Math.floor(Math.random() * 3);
    if (rand == 1)
      this.popUpImage = Bench;
    else if (rand == 2)
      this.popUpImage = Tree;
    else
      this.popUpImage = Phone;
  }

  private onPopUpClose() {
    this.showPopUp = false;
  }

  private onPopUpOpen() {
    this.showPopUp = true;
  }
}
